import { dict, type Content } from "./content";

export type Locale = "ja" | "en";

const STORAGE_KEY = "tane.locale";

function detect(): Locale {
  // Honor a preference the visitor set via the toggle…
  if (typeof localStorage !== "undefined") {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === "ja" || saved === "en") return saved;
  }
  // …otherwise Japanese is always the default, regardless of browser language.
  return "ja";
}

class I18n {
  locale = $state<Locale>("ja");

  constructor() {
    this.locale = detect();
    this.#sync();
  }

  get t(): Content {
    return dict[this.locale];
  }

  #sync() {
    if (typeof document !== "undefined") {
      document.documentElement.lang = this.locale;
    }
  }

  set(locale: Locale) {
    this.locale = locale;
    this.#sync();
    if (typeof localStorage !== "undefined") {
      localStorage.setItem(STORAGE_KEY, locale);
    }
  }

  toggle() {
    this.set(this.locale === "ja" ? "en" : "ja");
  }
}

export const i18n = new I18n();
